<template>
  <div ref="menuItemsEditorCategoryEntrees">
    <div class="bg-blue-50 h-14 flex items-center justify-between pr-4">
      <div class="flex flex-grow h-full items-center mr-2">
        <div class="bg-blue-300 h-full mr-3 w-1" />
        <w-input
          :maxLength="40"
          :shape="hasCategoryErrors ? 'default' : 'clear'"
          :show-error="hasCategoryErrors"
          :value="category.name"
          class="flex-grow"
          placeholder="請輸入類別名稱"
          @input="onCategoryNameChanges($event, category)"
        />
      </div>
      <div class="flex-shrink-0">
        <w-button
          v-if="showRemoveButton"
          class="hover:text-red-500 !mr-9 text-gray-500"
          type="icon"
          @click="showRemoveCategoryDialog = true"
        >
          <i class="icon-trash" />
        </w-button>
        <w-button
          type="icon"
          @click="show = !show"
        >
          <i :class="show ? 'icon-up-chevron' : 'icon-down-chevron'" />
        </w-button>
      </div>
    </div>
    <section v-if="show">
      <draggable
        :list="entrees"
        @change="onDragChange"
        @start="onDragStart"
        @end="onDragEnd"
        handle=".icon-drag"
        group="MenuItemGroup"
      >
        <div
          v-for="(entree, index) in entrees"
          :key="`category-entree-${entree.index}`"
          :class="{
            'selected-entree': selectedEntreeIndex === entree.index
            || draggingKey == `${category.index}-${entree.index}`
          }"
          :data-key="`${category.index}-${entree.index}`"
          @click="$emit('entree-select', entree.index)"
          class="first:pt-3 flex items-center justify-between last:pb-3 pl-2 pr-4 py-1"
        >
          <div class="icon-drag cursor-pointer" />
          <w-input
            :max="40"
            :ref="`new-entree-name-${entree.index}`"
            :shape="isEntreeKeyInvalid(index, '_name') ? 'default' : 'clear'"
            :show-error="isEntreeKeyInvalid(index, '_name')"
            :value="entree.name"
            class="flex-grow mr-2"
            placeholder="請輸入品項名稱"
            @input="onNameChanges($event, entree)"
            @keydown.down.native.stop.prevent="onFocusNext($event, index, 'new-entree-name')"
            @keypress.enter.native.stop.prevent="
              onCheckAndAddNewEntree($event, index, category.index, 'new-entree-name')
            "
            @keydown.right.native.stop.prevent="onFocus($event, `new-entree-price-${entree.index}`)"
            @keydown.up.native.stop.prevent="onFocusPre($event, index, 'new-entree-name')"
          />
          <div class="flex items-center">
            <span class="mb-[1px]">$</span>
            <w-input
              :ref="`new-entree-price-${entree.index}`"
              :shape="isEntreeKeyInvalid(index, '_price') ? 'default' : 'clear'"
              :show-error="isEntreeKeyInvalid(index, '_price')"
              :value="entree.price"
              class="w-16"
              placeholder="0"
              type="number"
              @input="onPriceChanges($event, entree)"
              @keydown.down.native.stop.prevent="onFocusNext($event, index, 'new-entree-price')"
              @keypress.enter.native.stop.prevent="
                onCheckAndAddNewEntree($event, index, category.index, 'new-entree-price')
              "
              @keydown.left.native.stop.prevent="onFocus($event, `new-entree-name-${entree.index}`)"
              @keydown.up.native.stop.prevent="onFocusPre($event, index, 'new-entree-price')"
            />
            <w-button
              :class="{ '!mr-9': entree.name }"
              @click.prevent="onRemoveEntree(entree)"
              class="hover:text-red-500 text-gray-300"
              type="icon"
            >
              <i class="icon-trash" />
            </w-button>
            <w-button
              v-if="entree.name"
              @click.prevent="onCopyEntree(entree, index)"
              class="hover:text-blue-500 text-gray-300"
              type="icon"
            >
              <i class="icon-copy" />
            </w-button>
          </div>
        </div>
      </draggable>
      <w-button
        v-if="!hasEmptyEntrees"
        class="flex-grow-0 flex-shrink-0 !ml-6 my-2"
        color-type="secondary"
        size="sm"
        type="link"
        @click="addNewEntree(category.index)"
      >
        <i class="icon-plus mr-2" />
        <span>新增品項</span>
      </w-button>
    </section>
    <menu-common-dialog
      title="刪除類別"
      v-model="showRemoveCategoryDialog"
      @cancel="onCloseRemoveCategoryDialog"
      @close="onCloseRemoveCategoryDialog"
      @confirm="$emit('remove-category-with-entrees', category)"
    >
      <template #content>
        <p>確定刪除此類別嗎？類別內已有品項，刪除後將無法還原菜單品項。</p>
      </template>
    </menu-common-dialog>
  </div>
</template>

<script>
import MenuItemsEditorCategoryEntrees from './MenuItemsEditorCategoryEntrees';

export default MenuItemsEditorCategoryEntrees;
</script>

<style lang="scss" scoped>
@import 'MenuItemsEditorCategoryEntrees';
</style>
